'use client';
import React from 'react';
import { Container } from '../container';

import { BentoGrid } from '../products/bento-grid';

export const ProductFeatures = () => {
  return (
    <Container className="max-w-7xl mt-20 ">
      <BentoGrid />
      {/* <First />
      <Second />
      <Third /> */}
    </Container>
  );
};
